import { useNavigate } from "react-router-dom";

import GenericPopup from "@/shared-components/popups/components/GenericPopup";
import Text from "@/shared-components/text/components/Text";

import "./styles/PopUpCreateOptions.css";

const PopUpCreateOptions = ({ open, close,openDraftPopup, textOption, to }) => {
  const navigate = useNavigate();

  return (
    <>
      <GenericPopup open={open} darkerBlur className="remove-scrollbar">
        <div className="pop-up-artwork-create" onClick={(e) => {
          e.stopPropagation();
          close();
        }}>
          <div
            className="pop-up-artwork-create-container"
          >
            <div
              className="pop-up-artwork-create-options"
              onClick={() =>
                navigate(to, { state: { from: true } })
              }
            >
              <Text>{`New ${textOption}`}</Text>
            </div>

            <div
              className="pop-up-artwork-create-options"
              onClick={() => {
                close();
                openDraftPopup(true);
              }}
            >
              <Text>Open Drafts</Text>
            </div>
          </div>
        </div>
      </GenericPopup>
    </>
  );
};

export default PopUpCreateOptions;
